document.addEventListener('DOMContentLoaded', function () {
  const article = document.querySelector(
    'body.single-post article, body.page-template-product-knowledge-base article, body.page-template-product-highlights article'
  )

  if (!article) return

  article.querySelectorAll('pre').forEach(function (pre) {
    const btn = document.createElement('button')
    btn.className = 'copy-code-btn'
    btn.setAttribute('aria-label', 'Copy code')
    btn.innerHTML = '<span class="material-icons-outlined">content_copy</span>'

    btn.addEventListener('click', function () {
      const source = pre.querySelector('code') ? pre.querySelector('code').innerText : pre.innerText

      navigator.clipboard.writeText(source).then(function () {
        btn.innerHTML = '<span class="material-icons-outlined">check</span>'
        btn.classList.add('copied')

        setTimeout(function () {
          btn.innerHTML = '<span class="material-icons-outlined">content_copy</span>'
          btn.classList.remove('copied')
        }, 2000)
      })
    })

    const wrapper = document.createElement('div')
    wrapper.className = 'code-block'
    pre.parentNode.insertBefore(wrapper, pre)
    wrapper.appendChild(pre)
    wrapper.appendChild(btn)
  })
})
